import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import Icon from 'Pods/Shared/Icon/Icon'
import StarsRating from 'Pods/Shared/StarsRating'
import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

function JobApplicant({
  applicant,
  isActive = false,
  isNew,
  onChangeHeart,
  updateApplicant,
}) {
  const applicantId = applicant.id
  const attributes = applicant.attributes
  const roundedRating = numeral(Number(attributes.rating)).format('0.0')
  const isActiveClassName = isActive ? ' is-active' : ''
  const isNewClassName = isNew ? ' is-new' : ''
  const totalRating = <StarsRating rating={roundedRating} fractions={2} customClass="height-12" readonly />

  return (
    <div className={`job-applicant${isActiveClassName}${isNewClassName}`} onClick={() => updateApplicant(applicant, true)}>
      <div className="job-applicant__heart" onClick={() => onChangeHeart(applicantId)}>
        <Icon type={['fas', 'heart']} className={attributes.starred ? 'is-red-heart' : 'is-grey'} />
      </div>
      <div className="job-applicant__avatar">
        <UserAvatar
          img={attributes.avatar.url}
          userName={attributes.username}
        />
        {attributes.updatesCount > 0 && <span className="indicator indicator--square">{attributes.updatesCount}</span>}
      </div>
      <div className="job-applicant__info">
        <span className={isNew ? 'text-semibold' : ''}>{attributes.username}</span>
        {isNew && <span className="job-applicant__label job-applicant__label--new">new</span>}
        <span className="job-applicant__offer">{numeral(attributes.priceOffer).format('$0')}</span>
        <div className="job-applicant__rating">
          {roundedRating > 0 ? (
            <Fragment>
              {totalRating}
              <span className="rating"><span className="text-semibold">{roundedRating}</span>/5</span>
            </Fragment>
          ) : (
            <Fragment>
              {totalRating}
              <span className="rating"><span className="text-semibold">N/A</span></span>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

JobApplicant.propTypes = {
  applicant: PropTypes.shape({
    id: PropTypes.string.isRequired,
    attributes: PropTypes.shape({
      username: PropTypes.string.isRequired,
      rating: PropTypes.number.isRequired,
      updatesCount: PropTypes.number.isRequired,
      priceOffer: PropTypes.number.isRequired,
      avatar: PropTypes.shape({
        url: PropTypes.string,
      }),
      starred: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  isActive: PropTypes.bool,
  isNew: PropTypes.bool.isRequired,
  onChangeHeart: PropTypes.func.isRequired,
  updateApplicant: PropTypes.func.isRequired,
}

export default JobApplicant
